// extracted by mini-css-extract-plugin
module.exports = {"item":"tag-module--item--13TON","link":"tag-module--link--rpWg4"};